import { TimeOfDayPeriod, TimeOfDayPeriodSchema } from "@greeter/date";
import * as z from "zod";

export const DailyOpeningHoursSchema = TimeOfDayPeriodSchema.extend({
  isOpen: z.boolean(),
});

export type DailyOpeningHours = TimeOfDayPeriod & {
  isOpen: boolean;
};
